export default {"src":"/_next/static/media/grok.cbde0875.svg","height":2531,"width":2531,"blurWidth":0,"blurHeight":0};